var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShopify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_480_3341",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_480_3341",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbElEQVQ4jX2UXWyTVRjHn3PO275t163bGIPNsYzFYW2CExInxsQEhBCMCBdemLgoISZyxYUmXhANF2oC1wRiCIjxAjFEjDEo6I24OLKMMcfI2q376Lqu3fq2b9u3b/t+n8eLfgzK4nN5znN++f+f/5NDEBE2q5wRH4ld9rIWC/WhnuEOb/+mbfWim54WzMS18eMH+k/73IF/Fs9+++DYROrG/4MAnymH2+f+DlrcSKrT92IX8kZyKTe6XBibln42Hf3Z/kptArq/em1y7SYifj/1ISLajnE7cvbftVvnR+DjH9oeJR5uChKe1ZgpLbw98KVUjgpEDGfujC5fWVX+HFtRtgb6LJ4/ceXY6YOftvm27A8dbRYD9VekYdhZffF25IsXth4ejV0smhHdUryudq+wnQNv8mI07p2cMw1MRXO56yduHg69W39YV4TxwsR06teZ9E+anYhK172ublHodLN2Ai4OvNJk2Tajrk5vL+dOTpWfVFAFlWz50v1XCIEWT69f7M9rkzkjKTJgABaHFk8/oz5Ey3GqKYvMG8tENwOZGZFBkydICE2pk32B/Xu6h7uaQwIVVUO6O/950Qx73N2cAxAAAEHwLUhhRCSENIBkB4EQIaM+frnr5Hu7v2HUVd+PWzMfUBAAwEakQAFQZO5kPqZZZZ+7qdJWlaoYKUQomY+3+fe8P3i1QllXZxFwNH5V0tY9QjciYM0ao0LZKCpGrtFaXktQCkUTDuw8CQCmo18eP5Io/LWz/YhuFzp9XRw4IrE5IiEAwCjTLEVW09ube55SJJWXKAEAaPf1VS+IIOuwUvhdNeZE1kkIck44J6y2NxYaa8pqXREFAATMlmYZDQBAXk8BgJt5Tg3dfWvXZ7oNAm1z0KIADqJTGzYACFRckZeeAplOOa8tCqw5IHpHYl+phgQAlNDjL55/o++MXI5SACSEc+JwIKS6wG7qjUvzDSDVsBOM+kTWI+vxi2Ovr6vhyvU7wa+3NoXK9hwFQCScQy1ucLm8USnMkW+AVCvj8BIgUiq2itum09FLYyHdViod3S2vaZaNBKqKahJEJq4XV1VD2UhNNTIOh6wePdh/Lthx6Le5My7mJ7UcylbGRYERdDgibiiiVChpeUXPt3haq6CimXIQHA7BjkO9rXtPDd2pO19Xw0u5X/xiHwBUUgMCAAgAjBDLKUnFtZ7Wvqo1uRwXKDSLMLJ8YV2drVNkLX5j+iMAEKifEOQcHHzySyUWGunC6oa18ZWLpgMtro7Jte8W5B8Htgy3eXp1R41INxVzsd03yLlBCNicIEdk9SkBI654bQMIIkayfyTyj5LqdFp5UNBnZB1sDm4GbR7wiyEADgA+kScz7okIcwuEELQcU7PKWXW5OxC8+0kYGj42w1GLZlrW4mk1klQeJ5WHRWPWtGVECPhBygbvTWkWz7gEsdXTsWv7S4M7hnY/t/fV/jcbQQ1lcaNkZQt6QiotSPrUxPwjQx3YN7Dv+c5QV2BHs6eNbCwD/AcLSa+xV+jnnAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopify);
export default __webpack_public_path__ + "static/media/icon-shopify.1d25347e2b5df9fd96f5aa9c773bf050.svg";
export { ForwardRef as ReactComponent };